module.exports = __webpack_public_path__ + "images/fógraí.ie-gabháil-scáileáin-leathanach-lamairne-1234w.webp";